export default __webpack_public_path__ + "static/media/alten.79077215.svg";